export function getReturnCase(comptype: string) {
  switch (comptype) {
    case 'FullWidthContainer':
      return '<div class="dy_fn_container is-fullwidth is-adjacent"><div class="dy_fn_container__col">';
    case 'FullBleedContainer':
      return '<div class="dy_fn_container is-fullbleed is-adjacent"><div class="dy_fn_container__col">';
    case 'RichTextCollection':
      return '<div class="dy_fn_container is-fullbleed is-adjacent has-background-gray"><div class="dy_fn_container__col">';
    case 'RichTextCollection_noBG':
      return '<div class="dy_fn_container is-fullbleed is-adjacent"><div class="dy_fn_container__col">';
    case 'Container 50-50':
      return '<div class="dy_fn_container is-5050 is-adjacent ">';
    case 'RichText':
      return '<div class="dy_fn_rte">';
    case 'Image':
      return '<div class="dy_fn_image__media">';
    case '50_50_Col_inside':
      return '<div class="dy_fn_container__col"><div class="dy_fn_rte">';
    case 'PageHeader':
      return '<div class="dy_finraletters_component dy_finraletters_page-header "><h1 class="dy_finraletters_page-header__title">';
    case 'StaticResourceListing':
      return '<div class="dy_finraletters_component dy_finraletters_resource-listing"><div class="dy_finraletters_resource-listing__body"><div class="dy_finraletters_block dy_finraletters_product-rates dy_finraletters_product-rates--all js-showmore-resources"><div class="dy_finraletters_product-rates__list js-showmore__list">';
    default:
      return '';
  }
}

export function getReturnCaseEnd(comptype: string) {
  switch (comptype) {
    case 'FullWidthContainer':
      return '</div></div>';
    case 'FullBleedContainer':
      return '</div></div>';
    case 'RichTextCollection':
      return '</div></div></div>';
    case 'RichTextCollection_noBG':
      return '</div></div></div>';
    case 'Container 50-50':
      return '</div>';
    case 'RichText':
      return '</div>';
    case 'Image':
      return '</div>';
    case '50_50_Col_inside':
      return '</div></div>';
    case 'PageHeader':
      return '</h1></div>';
    case 'StaticResourceListing':
      return '</div></div></div></div>';
    default:
      return '';
  }
}
